import React from 'react';
import { Outlet, Link, useLocation, useNavigate } from 'react-router-dom';
import { Container, Row, Col, Nav, Badge } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faTachometerAlt, faCubes, faComments, 
  faEnvelope, faSignOutAlt, faUser
} from '@fortawesome/free-solid-svg-icons';
import { useAuth } from '../../context/AuthContext';

function MainLayout() {
  const { currentUser, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  
  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const getTitle = () => {
    const path = location.pathname;
    if (path === '/') return 'Dashboard';
    if (path === '/framework') return 'Framework';
    if (path === '/channels') return 'Channels';
    if (path === '/messages') return 'Messages';
    if (path.includes('/conversation/')) return 'Conversation';
    return 'AI Integration Platform';
  };
  
  return (
    <Container fluid>
      <Row>
        {/* User Sidebar - Updated with professional colors */}
        <Col md={3} lg={2} className="p-0 user-sidebar min-vh-100">
          <div className="d-flex align-items-center justify-content-center p-3 user-header">
            <h4 className="text-white m-0 fw-bold">AI Integration</h4>
          </div>
          <hr className="mt-0 mb-3 user-divider" />
          
          <Nav className="flex-column user-nav">
            <Link to="/" className={`nav-link user-nav-link ${location.pathname === '/' ? 'active' : ''}`}>
              <FontAwesomeIcon icon={faTachometerAlt} className="me-2" /> Dashboard
            </Link>
            <Link to="/framework" className={`nav-link user-nav-link ${location.pathname === '/framework' ? 'active' : ''}`}>
              <FontAwesomeIcon icon={faCubes} className="me-2" /> Framework
            </Link>
            <Link to="/channels" className={`nav-link user-nav-link ${location.pathname === '/channels' ? 'active' : ''}`}>
              <FontAwesomeIcon icon={faComments} className="me-2" /> Channels
            </Link>
            <Link to="/messages" className={`nav-link user-nav-link ${location.pathname === '/messages' ? 'active' : ''}`}>
              <FontAwesomeIcon icon={faEnvelope} className="me-2" /> Messages2
            </Link>
            
            <hr className="my-2 user-divider" />
            
            <Nav.Link onClick={handleLogout} className="nav-link user-nav-link">
              <FontAwesomeIcon icon={faSignOutAlt} className="me-2" /> Logout
            </Nav.Link>
          </Nav>
        </Col>
        
        {/* Main Content */}
        <Col md={9} lg={10} className="p-4 user-content">
          <div className="d-flex justify-content-between align-items-center mb-4">
            <h2 className="user-title">{getTitle()}</h2>
            <div className="user-info">
              <span className="me-2 user-name">{currentUser?.name}</span>
              <Badge bg="success" className="user-badge">
                <FontAwesomeIcon icon={faUser} className="me-1" /> User
              </Badge>
            </div>
          </div>
          
          {/* Page content */}
          <Outlet />
        </Col>
      </Row>
    </Container>
  );
}

export default MainLayout;
